module.exports = __webpack_public_path__ + "static/img/title.708d795.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/news2/title.png
// module id = Rmxk
// module chunks = 7